import { Children, MouseEvent, useEffect, useState } from "react";
import cns from "classnames";
import {
  Badge,
  Box,
  IconButton,
  Typography,
  makeStyles,
  useTheme
} from "@material-ui/core";
import { Clear, KeyboardArrowDown, KeyboardArrowUp } from "@material-ui/icons";
import { Color, StarIcon } from "@bonliva-crm/ui";

type Props = {
  title: React.ReactNode;
  children: React.ReactNode;
  isDirty?: boolean;
  isClearable?: boolean;
  onClear?: (e: MouseEvent) => void;
  action?: React.ReactNode;
  favorite?: boolean;
  onSetFavorite?: (value: boolean) => void;
  initialExpanded?: boolean;
};

export function CollapsibleFavFilter(props: Props) {
  const [expanded, setExpanded] = useState(props.initialExpanded ?? false);

  const theme = useTheme();
  const classes = useStyles();

  useEffect(() => {
    setExpanded(props.initialExpanded ?? false);
  }, [props.initialExpanded]);

  const handleExpand = () => {
    setExpanded(!expanded);
  };

  const icon = expanded ? <KeyboardArrowUp /> : <KeyboardArrowDown />;

  return (
    <Box>
      <Box display="flex" alignItems="center" minHeight="60px">
        <IconButton onClick={() => props.onSetFavorite(!props.favorite)}>
          <StarIcon
            style={{
              fill: props.favorite ? theme.palette.primary.main : theme.palette.info.light
            }}
          />
        </IconButton>

        <Box flex="1" onClick={handleExpand}>
          <Badge
            color="primary"
            variant="dot"
            invisible={!props.isDirty}
            classes={{
              badge: "fav-filter-badge"
            }}
          >
            <Typography
              variant="body1"
              style={{
                color: Color.DetailsInput,
                fontWeight: 500,
                flex: 1,
                cursor: "pointer"
              }}
              onClick={handleExpand}
            >
              {props.title}
            </Typography>
          </Badge>
        </Box>

        {props.isClearable && (
          <IconButton onClick={props.onClear}>
            <Clear fontSize="small" />
          </IconButton>
        )}

        <IconButton onClick={handleExpand}>{icon}</IconButton>
      </Box>

      {props.children && (
        <Box
          pl={6}
          className={cns(classes.accordeon, { [classes.accordeonExpanded]: expanded })}
        >
          {Children.only(props.children)}
        </Box>
      )}
    </Box>
  );
}

const useStyles = makeStyles({
  accordeon: {
    overflow: "hidden",
    transition: "max-height 0.3s",
    maxHeight: 0
  },

  accordeonExpanded: {
    transition: "max-height 0.3s",
    maxHeight: "100vh",
    paddingBottom: 16
  }
});
